export default __webpack_public_path__ + "static/media/Jonak.8e146ea0.png";